var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C15.2812 4 18 6.6875 18 10C18 12.25 17.25 12.9375 13.25 19.3125C12.6562 20.25 11.3125 20.25 10.7188 19.3125C6.71875 12.9375 6 12.25 6 10C6 6.71875 8.65625 4 12 4ZM12 18.5C16 12.0625 16.5 11.7188 16.5 10C16.5 7.53125 14.4688 5.5 12 5.5C9.5 5.5 7.5 7.53125 7.5 10C7.5 11.7188 8 12.125 12 18.5ZM9.5 10C9.5 8.625 10.5938 7.5 12 7.5C13.375 7.5 14.5 8.625 14.5 10C14.5 11.4062 13.375 12.5 12 12.5C10.5938 12.5 9.5 11.4062 9.5 10Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.065fbd1012974644b6429c85d96688ee.svg";
export { ForwardRef as ReactComponent };